








































import { Component, Vue ,Prop, Model} from 'vue-property-decorator'
import { getDocumentListRequest, GetDocInfoById ,getDocInfoForEidt} from '@/api/supervision'
import TinymceEditor from '@/components/TinymceEditor'

@Component({
  components: { TinymceEditor },
})
export default class DocumentModal extends Vue {
@Prop({ type: Boolean }) readonly visible!: boolean;
@Prop({type:Object}) readonly docData!:any
@Prop({type:String}) readonly action!:any
@Prop({ type: Boolean }) readonly reset!: boolean;
  @Prop({ type: Boolean }) readonly isInfo!: boolean;

  private documentList: any = [];
  private documentInfo: any = {
    documentName: undefined,
    documentContent: '',
    documentIssueState:'',
    documentIssueTime:'',
    id:''
  };
  private setContent: any;
  created() {
    getDocumentListRequest('12345').then((res: any) => {
      if (res && res.status === 0) {
        this.documentList = res.data
      } else {
        this.$message.error(res.message)
      }
    })
   
  }
  content: any = '';
    private disabled: Boolean = false;

  mounted() {

     if(this.isInfo){
        this.disabled = true
         this.$nextTick(() => {
        this.setContent = this.$refs.editor
        this.setContent.setMode()
        // console.log(this.setContent.activeEditor)
      })
      } else{
        this.disabled = false
      }
    this.$nextTick(() => {
      this.setContent = this.$refs.editor
      if(this.docData){
          this.documentInfo.documentName = {key:this.docData.id,label:this.docData.documentName},
          this.setContent.setContent(this.docData.documentContent),
          this.documentInfo.id = this.docData.id
      }
    
    })
    


    //    if(this.action==='update'&&!this.reset){

    //   getDocInfoForEidt(this.docData.id).then((res:any)=>{
    //     if(res&&res.status===0){
    //       this.$nextTick(() => {
    //       this.documentInfo.documentName = {key:res.data.id,label:res.data.documentName},
    //       this.setContent.setContent(res.data.documentContent),
    //       this.documentInfo.id = res.data.id
    //       })
    //     } else {
    //       this.$message.error(res.message)
    //     }
    //   })
    // }
  }
  private getDocContent(e: any) {
    GetDocInfoById(e).then((res: any) => {
      if (res && res.status === 0) {
          setTimeout(()=>{ this.setContent = this.$refs.editor
          this.setContent.setContent(res.data.content)},300)
          this.documentInfo.documentIssueState = res.data.documentIssueState
           this.documentInfo.documentIssueTime = res.data.documentIssueTime
           this.documentInfo.id = res.data.id
        // this.$nextTick(() => {
        //   this.setContent = this.$refs.editor
        //   this.setContent.setContent(res.data.content)
        // })
      } else {
        this.$message.error(res.message)
      }
    })
  }
  handleOk() {
    const _this = this
    if(!this.documentInfo.documentName){
        this.$message.warning('请先选择一个文书模板')
        return 
    }
     if(!this.documentInfo.documentName.key){
        this.$message.warning('请先选择一个文书模板')
        return 
    }
    if(this.setContent.value===''){
        this.$message.warning('请填写模板内容')
        return 
    }
      var docData = {
          documentName:_this.documentInfo.documentName.label.trim(),
          documentContent:this.setContent.value,
           documentIssueTime:this.documentInfo.documentIssueTime,
           documentIssueState:this.documentInfo.documentIssueState,
           id:this.documentInfo.id
      }
      
      this.$emit('docCallBack',docData)
       this.$emit('closeDoc')
  }
  handleCancel() {
    this.documentInfo.documentName = undefined
    this.$emit('closeDoc')
  }
  private handleChange(e: any) {
    this.getDocContent(e.key)
  }
}
